import qs from 'qs'
import app from '../../main'

export default {
    namespaced: true,
    state: {
        orders: [],
        mobileOrders: [],
        pagination: {
            page: 1,
            totalPages: 1,
            totalProducts: 0,
            pageSize: 10
        },
        errors: {
            orders: {}
        }
    },
    actions: {
        getOrders({ commit, state }, payload) {
            commit('SET_ERRORS', {
                key: 'orders',
                val: ''
            })
            return this.$axios
                .get('/retailer/orders', {
                    params: {
                        ...payload,
                        items: state.pagination.pageSize
                    },
                    paramsSerializer: function(params) {
                        return qs.stringify(params, { arrayFormat: 'brackets' })
                    }
                })
                .then(({ data, headers }) => {
                    commit('SET_ORDERS', data)

                    commit('SET_PAGINATION', {
                        key: 'page',
                        val: headers['page'] * 1
                    })
                    commit('SET_PAGINATION', {
                        key: 'totalPages',
                        val: headers['total-pages'] * 1
                    })
                    commit('SET_PAGINATION', {
                        key: 'totalProducts',
                        val: headers['total-records'] * 1
                    })
                    commit('SET_PAGINATION', {
                        key: 'pageSize',
                        val: headers['page-size'] * 1
                    })
                    app.$Progress.finish()

                    if (
                        (payload && payload.isMobilePagination) ||
                        state.pagination.page == 1
                    ) {
                        commit('SET_MOBILE_ORDERS', data)
                    }
                })
                .catch(() => {
                    app.$Progress.fail()
                    commit('SET_ERRORS', {
                        key: 'orders',
                        val: 'Ошибка'
                    })
                })
        },
        createOrder({ commit, dispatch }, userData) {
            return this.$axios
                .post('/retailer/orders', { Contacts: userData })
                .then(({ data }) => {
                    console.log(data)
                    dispatch('cart/clearCart', {}, { root: true })
                    return data
                })
        },
        repeatOrder({ dispatch }, orderID) {
            return this.$axios
                .post(`/retailer/orders/repeat/${orderID}`)
                .then(() => {
                    dispatch('cart/getCart', {}, { root: true })
                })
        },
        clearOrders({ commit }) {
            commit('CLEAR_ORDERS')
        }
    },
    mutations: {
        SET_ERRORS(state, error) {
            state.errors[error.key] = error.val
        },
        SET_ORDERS(state, orders) {
            state.orders = orders
        },
        SET_MOBILE_ORDERS(state, payload) {
            if (state.pagination.page == 1) {
                state.mobileOrders = payload
            } else {
                state.mobileOrders = [...state.mobileOrders, ...payload]
            }
        },
        CLEAR_ORDERS(state) {
            state.orders = []
            state.mobileOrders = []
            state.pagination = {
                page: 1,
                totalPages: 1,
                totalRecords: 0,
                pageSize: 10
            }
        },
        SET_PAGINATION(state, payload) {
            state.pagination[payload.key] = payload.val
        }
    }
}
